import React from 'react';
import './App.css';
import {CssBaseline, ThemeProvider} from "@mui/material";
import {theme} from "./styling/theme";
import {RouterProvider} from "react-router";
import router from "./routing/router";

function App() {
  return (
      <React.StrictMode>
        <ThemeProvider theme={theme}>
          <CssBaseline>
            <RouterProvider router={router}/>
          </CssBaseline>
        </ThemeProvider>
      </React.StrictMode>
  );
}

export default App;
